import { closeMobileMenu } from "../mobile-menu";
import { parseUrlParameters } from "../url";
import { scrollTo } from "../scroll-to";

declare const $: any;

/** Starts the script for the home page */
export function initHomePage() {
    const logoHolder = document.querySelector(".logo-sticky") as HTMLElement;
    const siteHeader = document.querySelector("#site-header") as HTMLElement;

    const animation = new HeaderAnimation(logoHolder, siteHeader);
    animation.start();
}


/** Animates the header */
class HeaderAnimation {

    /** The threshold at which the header is stuck */
    private readonly threshold = -100;

    /** The header image element */
    private readonly logoContainer: HTMLElement;

    /** The services menu item */
    private readonly servicesMenuItem: HTMLElement;

    /** The services menu pop-up */
    private readonly servicesPopup: HTMLElement;

    /** The services menu pop-up spacer */
    private readonly servicesSpacer: HTMLElement;

    constructor(
        private readonly logoHolder: HTMLElement,
        private readonly header: HTMLElement
    ) {
        if(logoHolder != null) {
            this.logoContainer = logoHolder.querySelector(".logo-holder");
        }
        this.servicesMenuItem = header.querySelector("#services-menu-item");
        this.servicesPopup = document.querySelector('#services-pop-up');
        this.servicesSpacer = this.servicesPopup.querySelector('.spacer');
    }


    /** Stars the animation */
    public start() {

        // Scroll to section on load
        const params = parseUrlParameters();
        if(params.section) {
            switch(params.section) {
                case 'team':
                    scrollTo('.team-holder', 0);
                    break;
                case 'news':
                    scrollTo('.featured-holder', 0);
                    break;
                case 'branches':
                    scrollTo('.branch-holder', 0);
                    break;
            }
        }

        // Menu Events
        const linkItems = document.querySelectorAll('[data-scroll-to]');
        linkItems.forEach(item => {
            (item as HTMLElement).addEventListener('click', () => {
                scrollTo( (item as HTMLElement).getAttribute('data-scroll-to') );
            });
        });

        // Pop-Over Events
        this.servicesMenuItem.addEventListener('mouseenter', () => {
            this.servicesMenuItem.classList.add('active');
            this.showServices();
        });
        this.servicesSpacer.addEventListener('mouseenter', () => {
            this.servicesMenuItem.classList.add('active');
            this.showServices();
        });
        this.servicesSpacer.addEventListener('mouseleave', event => {
            const over = document.elementFromPoint(event.clientX, event.clientY);
            if(over && (over.classList.contains('pop-up') || over.classList.contains('pop-up-link'))) {
                return;
            }

            this.servicesMenuItem.classList.remove('active');
            this.hideServices();
        });
        this.servicesPopup.querySelector('.pop-up').addEventListener('mouseleave', () => {
            const over = document.elementFromPoint((event as any).clientX, (event as any).clientY);
            if(over == this.servicesSpacer) {
                return;
            }

            this.servicesMenuItem.classList.remove('active');
            this.hideServices();
        });

        this.update();
    }

    /** Updates the animation */
    private update() {
        this.servicesPopup.style.left = `${this.servicesMenuItem.getBoundingClientRect().left - 20}px`;
        this.servicesPopup.style.minWidth = `${this.servicesMenuItem.getBoundingClientRect().width + 20*2}px`;
        this.servicesSpacer.style.width = `${this.servicesMenuItem.getBoundingClientRect().width + 20*2}px`;

        // Tablet & Desktop
        if(document.body.clientWidth >= 950 && this.logoHolder) {
            const bounds = this.logoHolder.getBoundingClientRect();

            // // Stuck Status Class
            if(bounds.top <= this.threshold) {
                this.header.classList.add('stuck');
            } else {
                this.header.classList.remove('stuck');
            }

            // // Logo Transition
            let percent = bounds.top / this.threshold;
            if(percent < 0) percent = 0;

            const transform = `scale(${1.2 - 0.2*percent})`;
            this.logoContainer.style.transform = transform;
            this.logoContainer.style.webkitTransform = transform;
        }

        // Phone
        else if(this.logoContainer) {
            this.logoContainer.style.transform = '';
        }

        requestAnimationFrame(() => {
            this.update();
        });
    }

    // Services Popupu Visibility Controls
    private showServices() {
        this.servicesPopup.classList.add('visible');
    }

    private hideServices() {
        this.servicesPopup.classList.remove('visible');
    }

}
